import { lazy } from 'react';

export const AdminAccountingPage = lazy(() => import('./AdminAccountingPage'));
